import { ApplicationRef, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
} else {
  import('./perf-fn-spy').then(({ PerfFnSpy }) => {
    PerfFnSpy.patch('tick', ApplicationRef.prototype, 'tick');
  });
}

/* eslint-disable no-console */
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
/* eslint-enable no-console */
